/**
 * Shared Supabase configuration check.
 *
 * Used by middleware, server components, and client components to determine
 * whether Supabase is configured (vs. dev-auth fallback mode).
 */

export function isSupabaseConfigured(): boolean {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  return !!url && url.length > 0 && !url.includes("your-project");
}
